// extracted by mini-css-extract-plugin
export default {"button":"styles_button__cLVM3","button_text":"styles_button_text__miOBp","button_filled":"styles_button_filled__1g0v0","button_outlined":"styles_button_outlined__wiTHP"};